import zoneLocalStorageId from "utils/zone";

const { EndPoints } = require("settings/endpoints");
const { default: axiosInstance } = require("./axios");

export const fetchReportRole = (payload) => {
  return axiosInstance.get(EndPoints.REPORT_ROLE.LIST, {
    params: {
      zone_id: zoneLocalStorageId(),
    },
  });
};

export const addReportRole = (payload) => {
  return axiosInstance.post(EndPoints.REPORT_ROLE.CREATE, payload);
};

export const updateReportRole = (payload) => {
  return axiosInstance.put(EndPoints.REPORT_ROLE.UPDATE, payload);
};

export const deleteReportRole = (payload) => {
  const url = EndPoints.REPORT_ROLE.DELETE + `/ ${payload} `;
  return axiosInstance.delete(url);
};

export const downloadCSVReportRole = () => {
  return axiosInstance.put(EndPoints.REPORT_ROLE.DOWNLOAD_CSV, {
    responseType: "blob",
  });
};
